/* WaterFun mobile filter accordion (approved mockup, 2026-07-18).
 *
 * Dawn's MenuDrawer (assets/global.js) binds a click handler on EVERY
 * <summary> inside <menu-drawer> that turns it into a drill-in slide
 * panel with a focus trap - and facets.js re-runs that binding via
 * menu-drawer.bindEvents() after every AJAX filter update. A normal
 * listener on the summary can therefore never reliably win.
 *
 * Solution: one document-level listener in the CAPTURE phase. Capture
 * runs before the target-phase MenuDrawer handler, so stopPropagation()
 * here means Dawn's drill-in code never sees clicks on accordion
 * section headers - regardless of how many times bindEvents() re-runs.
 * Delegation also survives facets.js innerHTML re-renders for free.
 */
(function () {
  'use strict';
  if (window.wfMobileFacetsInit) return;
  window.wfMobileFacetsInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest('.wf-macc__summary');
      if (!summary) return;

      /* Block both the native <details> toggle (preventDefault) and
         Dawn's MenuDrawer handler (stopPropagation in capture phase),
         then drive the open state ourselves. */
      event.preventDefault();
      event.stopPropagation();

      var details = summary.closest('details');
      if (!details) return;

      var willOpen = !details.hasAttribute('open');
      if (willOpen) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
      summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    },
    true
  );

  /* Mirror the live result count ("174 מתוך 190 מוצרים") into the sticky
     apply button. The footer sits OUTSIDE the .js-filter elements that
     facets.js re-renders, so it would otherwise show a stale number.
     facets.js replaces the innerHTML of .mobile-facets__count on every
     update - observe it and copy the first number over. */
  function syncApplyCount() {
    var count = document.querySelector('.mobile-facets__count');
    var target = document.querySelector('.wf-apply-count');
    if (!count || !target) return;
    var match = count.textContent.replace(/[, ]/g, '').match(/\d+/);
    if (match) target.textContent = match[0];
  }

  /* In the sort panel a choice is final: close the panel right after it
     (facets.js has already started re-rendering the grid). */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('wf-mfilter__input')) return;
    var wrap = input.closest('.mobile-facets__wrapper[data-wf-mode="sort"]');
    if (!wrap || !input.closest('[id^="Details-Mobile-SortBy"]')) return;
    setTimeout(function () {
      var summary = wrap.querySelector('.mobile-facets__disclosure > summary');
      if (summary && wrap.querySelector('.mobile-facets__disclosure[open]')) summary.click();
    }, 250);
  });

  var countEl = document.querySelector('.mobile-facets__count');
  if (countEl) {
    new MutationObserver(syncApplyCount).observe(countEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  /* Dawn's closeMenuDrawer() strips the "open" attribute from every
     inner <details> when the drawer closes. Re-open the sort section
     (open-by-default in the approved mockup) each time the drawer is
     opened again. The drawer <details> lives outside the AJAX-rendered
     region, so binding once here is safe. */
  document.querySelectorAll('.mobile-facets__disclosure').forEach(function (drawer) {
    drawer.addEventListener('toggle', function () {
      /* Phone "sort" vs "filter" panel (mobile redesign 2026-09-30): the
         "מיון" button sets data-wf-mode="sort" on the wrapper before opening;
         closing clears it, so the "סינון" button always opens the filters. */
      if (!drawer.hasAttribute('open')) {
        var wrap = drawer.closest('.mobile-facets__wrapper');
        if (wrap) wrap.removeAttribute('data-wf-mode');
        return;
      }
      var sort = drawer.querySelector('[id^="Details-Mobile-SortBy"]');
      if (!sort) return;
      sort.setAttribute('open', '');
      var summary = sort.querySelector('.wf-macc__summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });
  });
})();
